import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=0fa00f4a&scoped=true&"
import script from "./BaseTextArea.vue?vue&type=script&lang=js&"
export * from "./BaseTextArea.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=0fa00f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa00f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
